import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Suppliers/data';
import {
  useSuppliers,
  useSuppliersEffects,
} from '@app/pages/Warehouses/Suppliers/hooks';
import { Filters, SuppliersTable } from '@app/pages/Warehouses/Suppliers/ui';
import { FiltersAccordion } from '@app/shared/components';

import '@pages/Warehouses/Suppliers/styles/Suppliers.scss';

export const Suppliers = () => {
  const {
    filters,
    unsavedFilters,
    onPaginate,
    range,
    onPageSizeChange,
    columns,
    total,
    tableData,
    onChangeSearchTerm,
    skipSearchTerm,
    onSearch,
    onSearchHandler,
    isPageLoading,
    isFetching,
    isPageForbidden,
    disabledSearch,
  } = useSuppliers();

  useSuppliersEffects({ onSearchHandler });

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            values={filters}
            unsavedValues={unsavedFilters}
            onChangeSearchTerm={onChangeSearchTerm}
            skipSearchTerm={skipSearchTerm}
            onSearch={onSearch}
            disabledSearch={disabledSearch}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <SuppliersTable
          columns={columns}
          data={tableData}
          filters={filters}
          total={total}
          range={range}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
          isPageLoading={isPageLoading}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
};
